import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../../../helpers';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { AppContextProvider } from '../../../../Services/AppContext';
import WizardBuilder from './WizardBuilder';

loadDOMComponent({
	selector: 'react-wizard-builder',
	callback: ({ container, context, props }) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<WizardBuilder />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
